import { FC, useEffect, useRef } from 'react'
import { slugs } from '@/constants/slugs'

interface Props {
  videoSrc: string
  paused?: boolean
  theatricalSlug: string
}

export const BackgroundVideo: FC<Props> = ({ videoSrc, paused = false, theatricalSlug }) => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const isVideoErrorRef = useRef(false)
  const isPlayingRef = useRef(false)

  useEffect(() => {
    const video = videoRef.current
    const videoError = isVideoErrorRef.current

    if (!video || videoError) return

    const handlePlayback = async () => {
      try {
        if (paused && isPlayingRef.current) {
          video.pause()
          isPlayingRef.current = false
        } else if (!paused && !isPlayingRef.current) {
          await video.play()
          isPlayingRef.current = true
        }
      } catch (err) {
        isVideoErrorRef.current = true
      }
    }

    handlePlayback()
  }, [paused])

  return (
    <div
      className={`absolute inset-0 h-full transition-opacity duration-1000 ${
        isVideoErrorRef.current ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <video
        key={videoSrc}
        ref={videoRef}
        id={videoSrc}
        className="!h-full w-full overflow-hidden object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        onError={() => {
          isVideoErrorRef.current = true
        }}
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {theatricalSlug === slugs.senior && <div className={'absolute inset-0  h-full w-full bg-black opacity-30'}></div>}
    </div>
  )
}
